import { render, staticRenderFns } from "./ErrorPanel.vue?vue&type=template&id=083aefdf&scoped=true"
import script from "./ErrorPanel.vue?vue&type=script&lang=js"
export * from "./ErrorPanel.vue?vue&type=script&lang=js"
import style0 from "./ErrorPanel.vue?vue&type=style&index=0&id=083aefdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083aefdf",
  null
  
)

export default component.exports